import React from 'react';
import styled from 'styled-components';
import GlitchyText from './glitch';
import Panda from '../images/panda';

const HeroContainer = styled.div`
  margin: 2.5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const PandaWrapper = styled.div`
  width: 8rem;
  height: auto;
  @media (max-width: 768px) {
    width: 5rem;
  }
`;

const NameWrapper = styled.div`
  margin-left: 1.5rem;
`;

const FirstName = styled(GlitchyText)`
  font-weight: 700;
  font-size: 4.5rem;
  display: block;
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;
const LastName = styled(GlitchyText)`
  font-weight: 500;
  font-size: 2.5rem;
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Hero = ({ heading, subheading }) => {
  return (
    <HeroContainer>
      <PandaWrapper>
        <Panda />
      </PandaWrapper>
      <NameWrapper>
        <FirstName>{heading}</FirstName>
        <LastName>{subheading}</LastName>
      </NameWrapper>
    </HeroContainer>
  );
};

export default Hero;
